import { RootState } from '@vfde-fe/sails_core';
import { CONTAINER_TARIFF } from 'Constant';
import { createSelector, Selector } from 'reselect';
import { Atomic } from '../DeviceDetail/interfaces/api';
import { selectAtomicDevice } from '../Options/selectors';
import { IInitialState as IInitialStateTariff  } from './interfaces/state';
import { IInitialState as IInitialStateOptions } from '../Options/interfaces/state';
import { IInitialState as IInitialDeviceDetail } from '../DeviceDetail/interfaces/state';
import { initialState } from './reducer';

const selectTariffContainerState = (state: RootState<IInitialStateTariff>) => state[CONTAINER_TARIFF] || initialState;

const selectSubscriptionId = (): Selector<RootState<IInitialStateTariff>, IInitialStateTariff['subscriptionId']> =>
    createSelector(
        selectTariffContainerState,
        state => state.subscriptionId,
    );

const selectSalesChannel = (): Selector<RootState<IInitialStateTariff>, IInitialStateTariff['salesChannel']> =>
    createSelector(
        selectTariffContainerState,
        state => state.salesChannel,
    );

const selectSubscription = (): Selector<RootState<IInitialDeviceDetail & IInitialStateOptions>, Atomic['subscription'] | undefined> =>
    createSelector(
        selectAtomicDevice(),
        device => device?.subscription,
    );

const selectHasSubscription = (): Selector<RootState<IInitialStateTariff & IInitialDeviceDetail & IInitialStateOptions>, boolean> =>
    createSelector(
        selectSubscriptionId(), selectSubscription(),
        (subscriptionId, subscription) => !!subscriptionId && !!subscription,
    );

const selectGigakombi = (): Selector<RootState<IInitialStateTariff>, boolean> =>
    createSelector(
        selectTariffContainerState, selectSubscriptionId(),
        (state, subscriptionId) => state.gigakombi && !!subscriptionId,
    );

const selectIsGigakombiEligible = (): Selector<RootState<IInitialStateTariff>, boolean> =>
    createSelector(selectTariffContainerState, state => state.gigakombi && !!state.gigakombiToken);

export {
    selectSubscriptionId,
    selectSalesChannel,
    selectSubscription,
    selectHasSubscription,
    selectGigakombi,
    selectIsGigakombiEligible,
};
